module.exports = __webpack_public_path__ + "img/testimonial-4-61x61_1testimonial-4-61x61.8dde1293.png";